// import { validateJWT } from "../utils/validateJWT";
import { readFromStorage } from "../utils/webStorage";

export const UserGuard = (): boolean => {
	const token = readFromStorage('accessToken');
	// const isValid = validateJWT(token);
	return !!token;
};
